// extracted by mini-css-extract-plugin
export default {"rightShiftedRow":"rewrite-script-patient-filter_rightShiftedRow__97ISf"};